import styled from '@emotion/styled'

export const StyleFooterWrapper = styled.div`
  width: full;
  height: auto;
  background-color: ${(props: any) => props.theme.colors.secondary100};
  display: flex;
  gap: 20px;
  padding: 30px 40px;
  flex: row;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const StyleLogoWrapper = styled.div``

export const StyleImage = styled.img`
  width: 300px;
  @media (max-width: 768px) {
    width: 300px;
  }
  @media (max-width: 480px) {
    width: 250px;
  }
`

export const StyleRightSectionWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  padding: 0 100px;
  @media (max-width: 480px) {
    flex-direction: column;
  }
`

export const StyleUseFulLinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`

export const StyleQuickLoginWrapper = styled(StyleUseFulLinkWrapper)``

export const StyleGetInTouchWrapper = styled(StyleUseFulLinkWrapper)``

export const StyleCopywriteWrapper = styled.div`
  background-color: ${(props: any) => props.theme.colors.secondary100};
  width: full;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 16px 0;
`
